module.exports = __webpack_public_path__ + "static/media/musio_price_introduction_mobile.8fff3ac0.svg";